/**
 * © 2025 Grupo Salamander SAPI de CV
 * Author: Pablo Adoue Peralta
 *
 * Translation provider implementation that manages translation data for different locales.
 * Follows Single Responsibility Principle by handling only translation data retrieval.
 *
 * */

import type { Ti18nLocale, Ti18nTranslationProvider } from '../types'

export class TranslationProvider implements Ti18nTranslationProvider {
  private translations: Record<Ti18nLocale, Record<string, string>>

  constructor(translations: Record<Ti18nLocale, Record<string, string>>) {
    this.translations = { ...translations }
  }

  getTranslation(key: string, locale: Ti18nLocale): string | undefined {
    return this.translations[locale]?.[key]
  }

  addTranslations(
    locale: Ti18nLocale,
    translations: Record<string, string>
  ): void {
    this.translations[locale] = {
      ...this.translations[locale],
      ...translations,
    }
  }

  hasKey(key: string): boolean {
    return Object.values(this.translations).some((localeTranslations) =>
      Object.prototype.hasOwnProperty.call(localeTranslations, key)
    )
  }
}
